
const env = process.env.REACT_APP_ENV;
const devEnv = ['development', 'devProd'];
// 用户登录API地址 http://192.168.50.229:9000/ 测试: https://suibian.gamelexi.com http://localhost:9000
export const DEFAULTORIGIN = devEnv.includes(env) ? 'https://suibian.gamelexi.com' : 'https://wangwang.gamelexi.com';
// http://192.168.50.229:9000
export const APIPREFIX = devEnv.includes(env) ?  'https://devsuibian.gamelexi.com' : 'https://admng.gamelexi.com';

export const PAGESIZE = 10;

export const IMGCOUNT = 10;

export const DefaultCount = {
    total: 0,
    success: 0,
    fail:0
};

export const DefaultPageInfo = {
    pageSize: 100,
    page:1
};

export const TIMEOUT = 1800000;

export const NavMapping = {
    'google-ads': 'google',
    'facebook-ads': 'facebook',
    'demand-ads': 'demand'   
};

export const ActionType = {
    Modify: 'modify',
    Submit: 'Submit'
}

export const Mode = {
    Multiple: 'multiple',
    Single: 'single'
}

export const API_Info = {
    single: {
        view: '/single/app/view',
        create: '/single/app/create'
    },
    multi: {
        view: '/mult/app/view',
        create: '/mult/app/create'
    }
}

export const AdsCategory = {
    google: `/admng/google`,
    facebook: `/admng/fb`,
    demand: `/admng/demand`
}

export const PlatformType = {
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    BING: 'bing'
}

export const getUrlPrefix = () => {
    const adsCategory = sessionStorage.getItem('adsCategory');
    return AdsCategory[adsCategory] || AdsCategory.google;
};

export const RoiErrorType = {
    CAMPAIGN_BIDDING: 'CAMPAIGN_BIDDING',
    CAMPAIGN_BUDGET_AND_BIDDING: 'CAMPAIGN_BUDGET_AND_BIDDING',
    CAMPAIGN_BUDGET: 'CAMPAIGN_BUDGET'
}
// 用于橙色历史记录
export const RoiTypeMapping = {
    'campaignBiddingAmount': RoiErrorType.CAMPAIGN_BIDDING,
    'campaignBudgetAmount': RoiErrorType.CAMPAIGN_BUDGET
}

export const RoiErrorTypeList = [RoiErrorType.CAMPAIGN_BIDDING, RoiErrorType.CAMPAIGN_BUDGET_AND_BIDDING, RoiErrorType.CAMPAIGN_BUDGET];

export const MessageStatus = {
    COMPLETED: 'COMPLETED',
    PROCESSING: 'PROCESSING',
    FAILED: 'FAILED'
};

export const SystemError = '系统异常';
// * 用户信息加密密钥
export const UserSecretKey = 'can.use.middleware.sites';

export const DefaultPlatForms = ['google', 'facebook', 'bing'];

export const RESOURCETYPE = {
    DEMAND_VIDEO: 'DEMAND_VIDEO',
    DEMAND_IMAGE: 'DEMAND_IMAGE',
    DISPLAY: 'DISPLAY'
}

export const ADSENSETYPE = {
    DEMAND_GEN: 'DEMAND_GEN',
    DISPLAY: 'DISPLAY',
    PERFORMANCE_MAX: 'PERFORMANCE_MAX',
    SEARCH: 'SEARCH',
    VIDEO: 'VIDEO'
}

export const EnglishCountry = [{label:'Afghanistan',value:2004,code:'AF'},
{label:'Albania',value:2008,code:'AL'},
{label:'Antarctica',value:2010,code:'AQ'},
{label:'Algeria',value:2012,code:'DZ'},
{label:'American Samoa',value:2016,code:'AS'},
{label:'Andorra',value:2020,code:'AD'},
{label:'Angola',value:2024,code:'AO'},
{label:'Antigua and Barbuda',value:2028,code:'AG'},
{label:'Azerbaijan',value:2031,code:'AZ'},
{label:'Argentina',value:2032,code:'AR'},
{label:'Australia',value:2036,code:'AU'},
{label:'Austria',value:2040,code:'AT'},
{label:'The Bahamas',value:2044,code:'BS'},
{label:'Bahrain',value:2048,code:'BH'},
{label:'Bangladesh',value:2050,code:'BD'},
{label:'Armenia',value:2051,code:'AM'},
{label:'Barbados',value:2052,code:'BB'},
{label:'Belgium',value:2056,code:'BE'},
{label:'Bhutan',value:2064,code:'BT'},
{label:'Bolivia',value:2068,code:'BO'},
{label:'Bosnia and Herzegovina',value:2070,code:'BA'},
{label:'Botswana',value:2072,code:'BW'},
{label:'Brazil',value:2076,code:'BR'},
{label:'Belize',value:2084,code:'BZ'},
{label:'Solomon Islands',value:2090,code:'SB'},
{label:'Brunei',value:2096,code:'BN'},
{label:'Bulgaria',value:2100,code:'BG'},
{label:'Myanmar (Burma)',value:2104,code:'MM'},
{label:'Burundi',value:2108,code:'BI'},
{label:'Belarus',value:2112,code:'BY'},
{label:'Cambodia',value:2116,code:'KH'},
{label:'Cameroon',value:2120,code:'CM'},
{label:'Canada',value:2124,code:'CA'},
{label:'Cabo Verde',value:2132,code:'CV'},
{label:'Central African Republic',value:2140,code:'CF'},
{label:'Sri Lanka',value:2144,code:'LK'},
{label:'Chad',value:2148,code:'TD'},
{label:'Chile',value:2152,code:'CL'},
{label:'China',value:2156,code:'CN'},
{label:'Christmas Island',value:2162,code:'CX'},
{label:'Cocos (Keeling) Islands',value:2166,code:'CC'},
{label:'Colombia',value:2170,code:'CO'},
{label:'Comoros',value:2174,code:'KM'},
{label:'Republic of the Congo',value:2178,code:'CG'},
{label:'Democratic Republic of the Congo',value:2180,code:'CD'},
{label:'Cook Islands',value:2184,code:'CK'},
{label:'Costa Rica',value:2188,code:'CR'},
{label:'Croatia',value:2191,code:'HR'},
{label:'Cyprus',value:2196,code:'CY'},
{label:'Czechia',value:2203,code:'CZ'},
{label:'Benin',value:2204,code:'BJ'},
{label:'Denmark',value:2208,code:'DK'},
{label:'Dominica',value:2212,code:'DM'},
{label:'Dominican Republic',value:2214,code:'DO'},
{label:'Ecuador',value:2218,code:'EC'},
{label:'El Salvador',value:2222,code:'SV'},
{label:'Equatorial Guinea',value:2226,code:'GQ'},
{label:'Ethiopia',value:2231,code:'ET'},
{label:'Eritrea',value:2232,code:'ER'},
{label:'Estonia',value:2233,code:'EE'},
{label:'South Georgia and the South Sandwich Islands',value:2239,code:'GS'},
{label:'Fiji',value:2242,code:'FJ'},
{label:'Finland',value:2246,code:'FI'},
{label:'France',value:2250,code:'FR'},
{label:'French Polynesia',value:2258,code:'PF'},
{label:'French Southern and Antarctic Lands',value:2260,code:'TF'},
{label:'Djibouti',value:2262,code:'DJ'},
{label:'Gabon',value:2266,code:'GA'},
{label:'Georgia',value:2268,code:'GE'},
{label:'The Gambia',value:2270,code:'GM'},
{label:'Germany',value:2276,code:'DE'},
{label:'Ghana',value:2288,code:'GH'},
{label:'Kiribati',value:2296,code:'KI'},
{label:'Greece',value:2300,code:'GR'},
{label:'Grenada',value:2308,code:'GD'},
{label:'Guam',value:2316,code:'GU'},
{label:'Guatemala',value:2320,code:'GT'},
{label:'Guinea',value:2324,code:'GN'},
{label:'Guyana',value:2328,code:'GY'},
{label:'Haiti',value:2332,code:'HT'},
{label:'Heard Island and McDonald Islands',value:2334,code:'HM'},
{label:'Vatican City',value:2336,code:'VA'},
{label:'Honduras',value:2340,code:'HN'},
{label:'Hungary',value:2348,code:'HU'},
{label:'Iceland',value:2352,code:'IS'},
{label:'India',value:2356,code:'IN'},
{label:'Indonesia',value:2360,code:'ID'},
{label:'Iraq',value:2368,code:'IQ'},
{label:'Ireland',value:2372,code:'IE'},
{label:'Israel',value:2376,code:'IL'},
{label:'Italy',value:2380,code:'IT'},
{label:'Cote dIvoire',value:2384,code:'CI'},
{label:'Jamaica',value:2388,code:'JM'},
{label:'Japan',value:2392,code:'JP'},
{label:'Kazakhstan',value:2398,code:'KZ'},
{label:'Jordan',value:2400,code:'JO'},
{label:'Kenya',value:2404,code:'KE'},
{label:'South Korea',value:2410,code:'KR'},
{label:'Kuwait',value:2414,code:'KW'},
{label:'Kyrgyzstan',value:2417,code:'KG'},
{label:'Laos',value:2418,code:'LA'},
{label:'Lebanon',value:2422,code:'LB'},
{label:'Lesotho',value:2426,code:'LS'},
{label:'Latvia',value:2428,code:'LV'},
{label:'Liberia',value:2430,code:'LR'},
{label:'Libya',value:2434,code:'LY'},
{label:'Liechtenstein',value:2438,code:'LI'},
{label:'Lithuania',value:2440,code:'LT'},
{label:'Luxembourg',value:2442,code:'LU'},
{label:'Madagascar',value:2450,code:'MG'},
{label:'Malawi',value:2454,code:'MW'},
{label:'Malaysia',value:2458,code:'MY'},
{label:'Maldives',value:2462,code:'MV'},
{label:'Mali',value:2466,code:'ML'},
{label:'Malta',value:2470,code:'MT'},
{label:'Mauritania',value:2478,code:'MR'},
{label:'Mauritius',value:2480,code:'MU'},
{label:'Mexico',value:2484,code:'MX'},
{label:'Monaco',value:2492,code:'MC'},
{label:'Mongolia',value:2496,code:'MN'},
{label:'Moldova',value:2498,code:'MD'},
{label:'Montenegro',value:2499,code:'ME'},
{label:'Morocco',value:2504,code:'MA'},
{label:'Mozambique',value:2508,code:'MZ'},
{label:'Oman',value:2512,code:'OM'},
{label:'Namibia',value:2516,code:'NA'},
{label:'Nauru',value:2520,code:'NR'},
{label:'Nepal',value:2524,code:'NP'},
{label:'Netherlands',value:2528,code:'NL'},
{label:'Curacao',value:2531,code:'CW'},
{label:'Sint Maarten',value:2534,code:'SX'},
{label:'Caribbean Netherlands',value:2535,code:'BQ'},
{label:'New Caledonia',value:2540,code:'NC'},
{label:'Vanuatu',value:2548,code:'VU'},
{label:'New Zealand',value:2554,code:'NZ'},
{label:'Nicaragua',value:2558,code:'NI'},
{label:'Niger',value:2562,code:'NE'},
{label:'Nigeria',value:2566,code:'NG'},
{label:'Niue',value:2570,code:'NU'},
{label:'Norfolk Island',value:2574,code:'NF'},
{label:'Norway',value:2578,code:'NO'},
{label:'Northern Mariana Islands',value:2580,code:'MP'},
{label:'United States Minor Outlying Islands',value:2581,code:'UM'},
{label:'Micronesia',value:2583,code:'FM'},
{label:'Marshall Islands',value:2584,code:'MH'},
{label:'Palau',value:2585,code:'PW'},
{label:'Pakistan',value:2586,code:'PK'},
{label:'Panama',value:2591,code:'PA'},
{label:'Papua New Guinea',value:2598,code:'PG'},
{label:'Paraguay',value:2600,code:'PY'},
{label:'Peru',value:2604,code:'PE'},
{label:'Philippines',value:2608,code:'PH'},
{label:'Pitcairn Islands',value:2612,code:'PN'},
{label:'Poland',value:2616,code:'PL'},
{label:'Portugal',value:2620,code:'PT'},
{label:'Guinea-Bissau',value:2624,code:'GW'},
{label:'Timor-Leste',value:2626,code:'TL'},
{label:'Qatar',value:2634,code:'QA'},
{label:'Romania',value:2642,code:'RO'},
{label:'Russia',value:2643,code:'RU'},
{label:'Rwanda',value:2646,code:'RW'},
{label:'Saint Barthelemy',value:2652,code:'BL'},
{label:'Saint Helena, Ascension and Tristan da Cunha',value:2654,code:'SH'},
{label:'Saint Kitts and Nevis',value:2659,code:'KN'},
{label:'Saint Lucia',value:2662,code:'LC'},
{label:'Saint Martin',value:2663,code:'MF'},
{label:'Saint Pierre and Miquelon',value:2666,code:'PM'},
{label:'Saint Vincent and the Grenadines',value:2670,code:'VC'},
{label:'San Marino',value:2674,code:'SM'},
{label:'Sao Tome and Principe',value:2678,code:'ST'},
{label:'Saudi Arabia',value:2682,code:'SA'},
{label:'Senegal',value:2686,code:'SN'},
{label:'Serbia',value:2688,code:'RS'},
{label:'Seychelles',value:2690,code:'SC'},
{label:'Sierra Leone',value:2694,code:'SL'},
{label:'Singapore',value:2702,code:'SG'},
{label:'Slovakia',value:2703,code:'SK'},
{label:'Vietnam',value:2704,code:'VN'},
{label:'Slovenia',value:2705,code:'SI'},
{label:'Somalia',value:2706,code:'SO'},
{label:'South Africa',value:2710,code:'ZA'},
{label:'Zimbabwe',value:2716,code:'ZW'},
{label:'Spain',value:2724,code:'ES'},
{label:'South Sudan',value:2728,code:'SS'},
{label:'Sudan',value:2736,code:'SD'},
{label:'Suriname',value:2740,code:'SR'},
{label:'Eswatini',value:2748,code:'SZ'},
{label:'Sweden',value:2752,code:'SE'},
{label:'Switzerland',value:2756,code:'CH'},
{label:'Tajikistan',value:2762,code:'TJ'},
{label:'Thailand',value:2764,code:'TH'},
{label:'Togo',value:2768,code:'TG'},
{label:'Tokelau',value:2772,code:'TK'},
{label:'Tonga',value:2776,code:'TO'},
{label:'Trinidad and Tobago',value:2780,code:'TT'},
{label:'United Arab Emirates',value:2784,code:'AE'},
{label:'Tunisia',value:2788,code:'TN'},
{label:'Turkiye',value:2792,code:'TR'},
{label:'Turkmenistan',value:2795,code:'TM'},
{label:'Tuvalu',value:2798,code:'TV'},
{label:'Uganda',value:2800,code:'UG'},
{label:'Ukraine',value:2804,code:'UA'},
{label:'North Macedonia',value:2807,code:'MK'},
{label:'Egypt',value:2818,code:'EG'},
{label:'United Kingdom',value:2826,code:'GB'},
{label:'Guernsey',value:2831,code:'GG'},
{label:'Jersey',value:2832,code:'JE'},
{label:'Isle of Man',value:2833,code:'IM'},
{label:'Tanzania',value:2834,code:'TZ'},
{label:'United States',value:2840,code:'US'},
{label:'Burkina Faso',value:2854,code:'BF'},
{label:'Uruguay',value:2858,code:'UY'},
{label:'Uzbekistan',value:2860,code:'UZ'},
{label:'Venezuela',value:2862,code:'VE'},
{label:'Wallis and Futuna',value:2876,code:'WF'},
{label:'Samoa',value:2882,code:'WS'},
{label:'Yemen',value:2887,code:'YE'},
{label:'Zambia',value:2894,code:'ZM'},
{label:'Hong Kong',value:2344,code:'HK'},
{label:'Taiwan',value:2158,code:'TW'}
];

export const AllCountryCode = [
    "AD",
    "UAE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
]
